import { Link } from 'react-router-dom';

import styles from './Awards.module.css';
import rightChevron from './../../assets/icons/RightChevron.svg';

// Images
import PrizeBoxBest_1x from './../../assets/HomePage/AwardsRecognitions/1PrizeBoxBest/PrizeBoxBest_1x.webp';
import PrizeBoxBest_2x from './../../assets/HomePage/AwardsRecognitions/1PrizeBoxBest/PrizeBoxBest_2x.webp';
import PrizeBoxBest_M1x from './../../assets/HomePage/AwardsRecognitions/0Mobile/1PrizeBoxBest/PrizeBoxBest_1x.webp';
import PrizeBoxBest_M2x from './../../assets/HomePage/AwardsRecognitions/0Mobile/1PrizeBoxBest/PrizeBoxBest_2x.webp';

import PrizeBoxGolden_1x from './../../assets/HomePage/AwardsRecognitions/2PrizeBoxGolden/PrizeBoxGolden_1x.webp';
import PrizeBoxGolden_2x from './../../assets/HomePage/AwardsRecognitions/2PrizeBoxGolden/PrizeBoxGolden_2x.webp';
import PrizeBoxGolden_M1x from './../../assets/HomePage/AwardsRecognitions/0Mobile/2PrizeBoxGolden/PrizeBoxGolden_1x.webp';
import PrizeBoxGolden_M2x from './../../assets/HomePage/AwardsRecognitions/0Mobile/2PrizeBoxGolden/PrizeBoxGolden_2x.webp';

import PrizeBoxFirst_1x from './../../assets/HomePage/AwardsRecognitions/3PrizeBoxFirst/PrizeBoxFirst_1x.webp';
import PrizeBoxFirst_2x from './../../assets/HomePage/AwardsRecognitions/3PrizeBoxFirst/PrizeBoxFirst_2x.webp';
import PrizeBoxFirst_M1x from './../../assets/HomePage/AwardsRecognitions/0Mobile/3PrizeBoxFirst/PrizeBoxFirst_1x.webp';
import PrizeBoxFirst_M2x from './../../assets/HomePage/AwardsRecognitions/0Mobile/3PrizeBoxFirst/PrizeBoxFirst_2x.webp';


export default function AwardsComponent() {
    return (
        <Link to="/awards" className={styles.awards + ' section'}>
            <div className={styles.cardHeader}>
                <h2 className='D_HeadingSection'>Awards & Recognitions</h2>
                <span className='D_ViewAll'>VIEW ALL <img src={rightChevron} alt="Right Chevron" /></span>
            </div>
            <div className={styles.grid3 + ' section_content'}>
                <picture>
                    <source type="image/webp" media="(min-width:750px)" srcSet={PrizeBoxBest_1x + ' 1x, ' + PrizeBoxBest_2x + ' 2x'} alt="Logo of Best Employee Award" />
                    <source type="image/webp" media="(min-width:300px)" srcSet={PrizeBoxBest_M1x + ' 1x, ' + PrizeBoxBest_M2x + ' 2x'} alt="Logo of Best Employee Award" />
                    <img src={PrizeBoxBest_1x} alt="Logo of Best Employee Award" />
                </picture>
                <picture>
                    <source type="image/webp" media="(min-width:750px)" srcSet={PrizeBoxGolden_1x + ' 1x, ' + PrizeBoxGolden_2x + ' 2x'} alt="Logo of Golden Guru Award" />
                    <source type="image/webp" media="(min-width:300px)" srcSet={PrizeBoxGolden_M1x + ' 1x, ' + PrizeBoxGolden_M2x + ' 2x'} alt="Logo of Golden Guru Award" />
                    <img src={PrizeBoxGolden_1x} alt="Logo of Golden Guru Award" />
                </picture>
                <picture>
                    <source type="image/webp" media="(min-width:750px)" srcSet={PrizeBoxFirst_1x + ' 1x, ' + PrizeBoxFirst_2x + ' 2x'} alt="Logo of First Prize Winner" />
                    <source type="image/webp" media="(min-width:300px)" srcSet={PrizeBoxFirst_M1x + ' 1x, ' + PrizeBoxFirst_M2x + ' 2x'} alt="Logo of First Prize Winner" />
                    <img src={PrizeBoxFirst_1x} alt="Logo of First Prize Winner" />
                </picture>
            </div>
        </Link>
    );
}